//TODO: delete this file after new pricing migration
import useSWR from 'swr';
import { get } from '@/utils/client';

//lib
import { CURRENCY_SYMBOLS, FREQUENCIES } from '@/lib/billing/billing';

// API Endpoints
import { BILLING_SUBSCRIPTION } from '@/routes/apiEndpoints';
import type { AxiosError } from 'axios';
import type { SWRConfiguration, KeyedMutator } from 'swr';

export type MutateUserSubscription = KeyedMutator<UserSubscriptionType>;

export type OptionsAvailableType = 'competitors' | 'feeds' | 'hashtags' | 'profiles' | 'users';
export type PlanAvailableType = 'pro' | 'advanced' | 'enterprise' | 'trial';
export type SubscriptionOptionType = {
    count_add_ons: number;
    count_included: number;
    count_total: number;
    price: number;
    price_monthly: number;
    price_total: number;
};

export type UserSubscriptionType = {
    currency?: keyof typeof CURRENCY_SYMBOLS;
    frequency?: Lowercase<keyof typeof FREQUENCIES>;
    is_apple_subscription?: boolean;
    is_manual?: boolean;
    is_waiting_for_cancel?: boolean;
    is_waiting_for_downgrade?: boolean;
    next_renewal?: string;
    options: OptionalExceptFor<
        Record<OptionsAvailableType, SubscriptionOptionType>,
        'competitors' | 'feeds' | 'hashtags'
    >;
    options_price?: number;
    plan_price?: number;
    plan_price_monthly?: number;
    product_id?: string;
    product_key?: PlanAvailableType;
    product_title?: `${PlanAvailableType}_${Lowercase<keyof typeof FREQUENCIES>}`;
    taxes_percentage?: number;
    total?: number;
    trial_ends_at?: string;
    update_billing_address_url?: string;
    update_payment_method_url?: string;
};

const useBillingSubscription = (
    options?: SWRConfiguration<UserSubscriptionType, AxiosError<Error>>
) => {
    const {
        data: plan,
        mutate: mutateBillingSubscription,
        error: billingSubscriptionError,
        isLoading
    } = useSWR<UserSubscriptionType, AxiosError<Error>>(
        BILLING_SUBSCRIPTION,
        (url) => get(url).then((res) => res.data),
        {
            revalidateIfStale: false, // by default do not revalidate if there is data in cache
            shouldRetryOnError: false,
            revalidateOnFocus: false,
            ...options
        }
    );

    return {
        plan: plan,
        planProductId: plan?.product_id,
        isOnTrial: !plan?.product_id,
        mutateBillingSubscription,
        billingSubscriptionError,
        isLoading
    };
};

export default useBillingSubscription;
